<ng-container *ngIf="templateData$ | glxyAsyncStatus | async as result">
  <ng-container [ngSwitch]="result.status">
    <ng-container *ngSwitchCase="'loading'">
      <glxy-loading-spinner [fullHeight]="true" />
    </ng-container>

    <ng-container *ngSwitchDefault>
      <p>
        {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.EMAIL_BUILDER.ERROR_LOADING_CONTENT' | translate }}
      </p>
    </ng-container>

    <ng-container *ngSwitchCase="'loaded'">
      <glxy-page [pagePadding]="false">
        <glxy-page-toolbar>
          <glxy-page-title>
            <button mat-icon-button (click)="closeDialog()" color="primary">
              <mat-icon>arrow_back</mat-icon>
            </button>
            {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.EMAIL_BUILDER.EDIT_EMAIL' | translate }}
          </glxy-page-title>
          <glxy-page-actions>
            <button
              mat-raised-button
              [disabled]="result.status !== 'loaded' || htmlRendering"
              color="primary"
              (click)="saveAndClose()"
            >
              {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_HTML_EMAIL_TO_USER.EMAIL_BUILDER.SAVE_AND_CLOSE' | translate }}
            </button>
          </glxy-page-actions>
        </glxy-page-toolbar>

        <email-builder
          [emailContent]="result.value"
          (emailContentChanged)="stageDataForSaving($event)"
          (emailRenderUpdated)="stageRawHtmlForSaving($event)"
          (htmlRendering)="setHtmlRendering($event)"
          [advancedSections]="advancedSections"
          [previewHydrationParams]="previewHydrationData$ | async"
          [dynamicComponents]="dynamicComponents"
        >
          <div class="container" preview_header></div>
        </email-builder>
      </glxy-page>
    </ng-container>
  </ng-container>
</ng-container>
